export const ROLE_OPTIONS = [
  { value: "All", labelKey: "selectOption.allRoles" },
  { value: "admin", labelKey: "selectOption.admin" },
  { value: "operator", labelKey: "selectOption.operator" }
];

export const DEVICE_TYPE_FILTER_OPTIONS = [
  { value: "All", labelKey: "selectOption.allTypes" },
  { value: "Camera", labelKey: "selectOption.camera" },
  { value: "Drone", labelKey: "selectOption.drone" },
  { value: "Sensor", labelKey: "selectOption.sensor" }
];

export const DEVICE_STATUS_FILTER_OPTIONS = [
  { value: "All", labelKey: "selectOption.allStatuses" },
  { value: "Active", labelKey: "selectOption.active" },
  { value: "Inactive", labelKey: "selectOption.inactive" }
];

export const DEVICE_TYPE_ORDER_OPTIONS = [
  { value: "", labelKey: "selectOption.selectDeviceType" },
  { value: "Drone", labelKey: "selectOption.drone" },
  { value: "Sensor", labelKey: "selectOption.sensor" },
  { value: "Camera", labelKey: "selectOption.camera" }
];

export const SEVERITY_OPTIONS = [
  { value: "All", labelKey: "selectOption.allSeverities" },
  { value: "Low", labelKey: "selectOption.low" },
  { value: "Medium", labelKey: "selectOption.medium" },
  { value: "High", labelKey: "selectOption.high" }
];

export const DRONE_RUNWAY_STATUS_OPTIONS = [
  { value: "All", labelKey: "selectOption.allStatuses" },
  { value: "Open", labelKey: "selectOption.open" },
  { value: "Closed", labelKey: "selectOption.closed" }
];

export const ALERT_STATUS_OPTIONS = [
  { value: "All", labelKey: "selectOption.allStatuses" },
  { value: "Active", labelKey: "selectOption.active" },
  { value: "Complete", labelKey: "selectOption.complete" },
  { value: "Inferencing", labelKey: "selectOption.inferencing" },
  { value: "Human Verification", labelKey: "selectOption.humanVerification" },
  { value: "Processed", labelKey: "selectOption.processed" },
  { value: "Failed", labelKey: "selectOption.failed" }
];

export const ROWS_PER_PAGE_OPTIONS = [
  { value: 10, labelKey: "selectOption.rows10" },
  { value: 20, labelKey: "selectOption.rows20" },
  { value: 30, labelKey: "selectOption.rows30" },
  { value: 50, labelKey: "selectOption.rows50" }
];
